<template>
  <div
    class="half-full-size-teaser-wrapper"
    :class="halfFullSizeTeaserTabs.length > 1 ? 'half-size' : ''"
  >
    <half-full-size-teaser
      v-if="halfFullSizeTeaserTabs"
      v-for="(halfFullSizeTeaser, index) in halfFullSizeTeaserTabs"
      :key="index"
      :half-full-size-teaser="halfFullSizeTeaser"
    />
  </div>
</template>

<script>
  import HalfFullSizeTeaser from "./halfFullSizeTeaser";

  export default {
    components: {
      HalfFullSizeTeaser
    },
    props: {
      halfFullSizeTeaserTabs: Array,
    }
  };

</script>
